import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconSortArrowUpDown: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconSortArrowUpDown"><Path d="M18 2.58569L17.0858 3.49991H17V3.58569L13.5858 6.99991L15 8.41412L17 6.41412V17.5857L15 15.5857L13.5858 16.9999L17 20.4141V20.4999H17.0858L18 21.4141L18.9142 20.4999H19V20.4141L22.4142 16.9999L21 15.5857L19 17.5857V6.41412L21 8.41412L22.4142 6.99991L19 3.58569V3.49991H18.9142L18 2.58569Z" fill="currentColor"/><Path d="M3 2.99991V10.9999H11V2.99991H3Z" fill="currentColor"/><Path d="M3 12.9999V20.9999H11V12.9999H3Z" fill="currentColor"/></CentralIconBase>;
});

export default IconSortArrowUpDown;
